import { Spacing } from '@billy/design-system'
import styled from '@emotion/styled'
import SimpleBar from 'simplebar-react'

export const SettingsModuleHeaderWrapper = styled.header`
  width: 100%;
  padding-top: ${Spacing.S24};
  padding-bottom: ${Spacing.S24};
`

export const Header = styled.div`
  display: flex;
  align-items: center;
`

export const TitleWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: ${Spacing.S8};
`

export const HeaderTopActionsWrapper = styled.div`
  margin-top: -${Spacing.S16};
  margin-bottom: ${Spacing.S8};
`

export const SideActions = styled.aside`
  display: flex;
  flex-grow: 1;
  justify-content: flex-end;
  padding-left: ${Spacing.S16};
`

export const SettingsModuleContent = styled(SimpleBar)`
  display: flex;
  overflow: auto;
`
